<template>
    <div class="d-inline-block clearfix">
        <template v-for="button in buttons">
            <button type="button"
                    class="btn"
                    :class="button.styleClass"
                    @click="$emit('button', button.key)"
                    v-if="button.type === 'button' && isVisible(button)"
            >
                <font-awesome-icon v-if="button.icon !== undefined && button.icon !== null"
                                   :icon="button.icon"
                />
                <span>{{ button.name }}</span>
            </button>
            <accept-action
                    v-if="button.type === 'action' && isVisible(button)"
                    v-on:accepted="$emit('button', button.key)"
                    :modalText="button.modalText"
                    :modalIcon="button.icon"
                    :buttonIcon="button.icon"
                    :buttonName="button.name"
                    :buttonClass="button.styleClass"
            />
            <router-link v-if="button.type === 'link' && isVisible(button) && typeof getRouteLink(button) === 'object'"
                         class="btn"
                         :to="getRouteLink(button)"
                         :target="button.target === undefined ? '_self' : button.target"
                         :class="button.styleClass"
                         role="tab"
            >
                <font-awesome-icon v-if="button.icon !== undefined && button.icon !== null"
                                   :icon="button.icon"
                />
                <span>{{button.name}}</span>
            </router-link>

            <a v-if="button.type === 'link' && isVisible(button) && typeof getRouteLink(button) !== 'object'"
               class="btn"
               :href="getRouteLink(button)"
               :target="button.target === undefined ? '_self' : button.target"
               :class="button.styleClass"
               role="tab"
            >
                <font-awesome-icon v-if="button.icon !== undefined && button.icon !== null"
                                   :icon="button.icon"
                />
                <span>{{button.name}}</span>
            </a>


        </template>
    </div>
</template>
<script>
    import AcceptAction from './AcceptAction'

    export default {
        components: {
            AcceptAction
        },
        props: {
            buttons: {
                type: Array,
                'default': function () {
                    return [];
                }
            },
            data: {
                required: false,
            }
        },
        methods: {
            getRouteLink(button) {
                if (_.isFunction(button.to) === true) {
                    return button.to(this.data);
                }
                return button.to;
            },
            isVisible(button) {
                if (_.isFunction(button.visible) === true) {
                    return button.visible(this.data);
                }
                return button.visible === true || button.visible === undefined;
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/core/Buttons.vue